import {
  Checkbox,
  UpdateIconButton,
  ListMenu,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  pn,
} from "@compass/core";

import {
  ContributorListDto,
  ContributorListResource,
  Permission,
  PermissionAction,
  SortObject,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";

import { ListBeProperty } from "components";
import { contributorPageRoute } from "../ContributorPage/ContributorPage";
import { useContributorListMenuItems } from "./useContributorListMenuItems";

export const ContributorTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  contributors: ContributorListDto[];
  listTotal: number | undefined;
  resource: ContributorListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];
  const menuItems = useContributorListMenuItems({ permission: props.rootPermission, selectedIds: props.selectedIds });

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {menuItems.length > 0 && (
              <TableCell type="select">
                <ListMenu
                  selectedIds={props.selectedIds}
                  setSelectedIds={props.setSelectedIds}
                  listTotal={props.listTotal}
                  fetchFunction={() => props.getIdsPromise()}
                  actionMenuItems={menuItems}
                />
              </TableCell>
            )}

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ContributorListDto>("fullName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ContributorListDto>("currentTitle"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ContributorListDto>("currentPartner"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ContributorListDto>("currentSubPartner"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.contributors.map((contributorItem) => (
            <TableRow
              key={contributorItem.id}
              onClick={() => navigate(contributorPageRoute.getPath({ id: contributorItem.id, crudMode: "view" }))}
            >
              {menuItems.length > 0 && (
                <TableCell type="select">
                  <Checkbox
                    checked={props.selectedIds.includes(contributorItem.id)}
                    onClick={(e) => props.selectId(contributorItem.id)}
                  />
                </TableCell>
              )}
              <TableCell>{contributorItem.fullName}</TableCell>
              <TableCell>{contributorItem.currentTitle}</TableCell>
              <TableCell>{contributorItem.currentPartner}</TableCell>
              <TableCell>{contributorItem.currentSubPartner}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() => navigate(contributorPageRoute.getPath({ id: contributorItem.id, crudMode: "edit" }))}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
